import styled, { css } from 'styled-components';

// Import components
import { Button } from 'components/elements/index';
import { Modal } from 'antd';

// Import styles utilities
import { antModal, media } from 'components/styles';

export const ModalStyled = styled(Modal)`
	${antModal()}

	&& .ant-modal-content {
		padding: 2rem;

		${media.min.min(css`
			padding: 7rem 9rem;
		`)}

		& .ant-modal-header {
			padding: 0;

			& .ant-modal-title {
				font-size: 1.8rem;
				color: #ffffff;

				${media.min.min(css`
					font-size: 2.4rem;
				`)}
			}
		}
	}

	&& .ant-modal-body {
		padding: 0;
	}
`;

export const MainWrapper = styled.div`
	padding: 4rem 0;
	font-size: 1.6rem;
	color: ${({ theme }) => theme.graySemiSoft};
`;

export const ButtonWrapper = styled.div`
	padding: 0;
	display: flex;
	justify-content: space-around;

	& button {
		font-size: 1.4rem;
		height: 4.5rem;
		width: 12rem;

		${media.min.min(css`
			height: 6rem;
			width: 22rem;
			font-size: 1.6rem;
		`)}
	}

	button:nth-of-type(2) {
		margin-right: 0;
	}
`;

export const AcceptButton = styled(Button)`
	background: radial-gradient(
				57.43% 157.84% at 30.18% 5.11%,
				rgba(255, 255, 255, 0.2) 0%,
				rgba(155, 155, 155, 0.2) 36.68%,
				rgba(113, 112, 112, 0.2) 64.6%,
				rgba(78, 78, 78, 0.2) 100%
			)
			/* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
		linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)) !important;

	border: 1px solid #e0e0e04d !important;

	border-image-source: linear-gradient(
		180deg,
		rgba(224, 224, 224, 0.37) 0%,
		rgba(255, 255, 255, 0.5) 20.52%,
		rgba(106, 106, 106, 0.5) 65%
	);
`;
